/**
 * Tracks at most one expanded table row at a time (accordion behavior).
 * Use in tables with expandable child rows; call collapseAll() when switching tabs or resetting data.
 */
export class SingleRowExpansionState {
  private expandedRowId: string | null = null;

  toggle(rowId: string): void {
    if (!rowId) {
      return;
    }
    this.expandedRowId = this.expandedRowId === rowId ? null : rowId;
  }

  isExpanded(rowId: string): boolean {
    return !!rowId && this.expandedRowId === rowId;
  }

  collapseAll(): void {
    this.expandedRowId = null;
  }
}
